import './App.css';
import {Provider} from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import RootRouter from './navigation';
import createStore from './store';
import {ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import "react-toastify/dist/ReactToastify.css";


const firebaseConfig = {
	apiKey: "AIzaSyCVtyRQb92bHUfRsF0rsgE3H2K_ZdjQ0ZI",
	authDomain: "brainsprays-dapp.firebaseapp.com",
	projectId: "brainsprays-dapp",
	storageBucket: "brainsprays-dapp.appspot.com",
	messagingSenderId: "244868393512",
	appId: "1:244868393512:web:90cdd206ef53283970e31d",
	measurementId: "G-YXGR9P5XNQ"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// const {store, persistor} = createStore();

function App() {
  return (
	// <Provider store={store} >
		// <PersistGate loading={null} persistor={persistor}>	
        <div className="App">
        	<RootRouter />
			<ToastContainer
				position="top-left"
				autoClose={2500}
				hideProgressBar
				newestOnTop
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
		</div>
  );
}

export default App;
